import app from '#app/app'
import { config } from '#app/config'
import { appLayout } from '#app/init_app_layout.svelte.ts'
import preq from '#app/lib/preq'
import { addRoutes } from '#app/lib/router'
import { treq } from '#app/lib/treq'
import { commands } from '#app/radio'
import type { ActivityActor, ActivityId } from '#server/types/activity'
import type { AbsoluteUrl, Host } from '#server/types/common'
import type { Username } from '#server/types/user'
import { i18n } from '#user/lib/i18n'

export default {
  initialize () {
    addRoutes({
      '/activities(/)(:id)(/)': 'showActivity',
    }, controller)
  },
}

export interface SerializedActivityActor extends ActivityActor {
  handle: `@${Username}@${Host}`
}

const controller = {
  async showActivity (id: string) {
    try {
      // Lets the server actually validate the activity id
      const object = await treq('activitypub', 'get', 'activity', { id: id as ActivityId })
      const objectId = new URL(object.id).searchParams.get('id')
      const actorUrl = object.actor as AbsoluteUrl
      const actor = await preq.get(actorUrl) as SerializedActivityActor
      actor.handle = `@${actor.preferredUsername}@${config.publicHost}`
      const { default: Activity } = await import('./components/activity.svelte')
      appLayout.showChildComponent('main', Activity, { props: { actor, object } })
      app.navigate(`activities/${objectId}`, {
        metadata: {
          title: `${i18n('Activity')} - ${actor.name} (${actor.handle})`,
        },
      })
    } catch (err) {
      commands.execute('show:error', err)
    }
  },
} as const
